import {React,useState} from "react";
import {Link} from 'react-router-dom';
import { __ } from "@wordpress/i18n";
import dashboardIcon from '../../assets/images/dashboard.svg';
import settingsIcon from '../../assets/images/settings.svg';
import supportIcon from '../../assets/images/support.svg';
import featuredIcon from '../../assets/images/featured.svg';
import notificationIcon from '../../assets/images/notification.svg';
import programmelabIcon from '../../assets/images/pl_logo.svg';
import Logo from '../../assets/images/logo.svg';
import Notification from "../../components/Notifications/Notification";

import './Header.scss';
export default function Header() {
     // Toggle notifications panel
     const [showNotifications, setShowNotifications] = useState(false);

    // Toggle notifications panel
    const toggleNotifications = (e) => {
        e.preventDefault();
        setShowNotifications(!showNotifications);
    };

    return (
        <div className="pl-access-control-topbar purple-bg-90 secondary-text-color">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-xl-5 mb-3 mb-xl-0">
                        <div className="d-flex justify-content-center justify-content-lg-start align-items-center topbar-left">
                            <img className="plugin-logo" src={Logo}/>
                            <div className="plugin-name heading bold">{__( 'Access Control', "access-control" )}</div>
                            <ul className="d-flex align-items-center mb-0 gap-3 mt-2">
                                {/* <li className="heading-1 fw-600 dashboard-link">
                                    <Link to="/">
                                        <img src={dashboardIcon} alt="plugin-icon"/>
                                        {__( 'Dashboard', "access-control" )}
                                    </Link>
                                </li>
                                <li className="heading-1 semi-bold">
                                    <Link to="/roles/edit-role-capabilities">
                                        <img src={settingsIcon} alt="plugin-icon"/>
                                        {__( 'Settings', "access-control" )}
                                    </Link>
                                </li> */}
                            </ul>
                        </div>                        
                    </div>
                    <div className="col-xl-7">
                        <div className="row g-0 justify-content-center justify-content-lg-end align-items-center topbar-right">                                
                            <div className="col-auto header-logos">
                                <a href="https://wordpress.org/support/plugin/access-control/" target="_blank">
                                <img src={supportIcon} alt="plugin-icon"/>
                                </a>
                            </div>
                            <div className="col-auto header-logos">
                                <a href="https://wordpress.org/support/plugin/access-control/reviews/#new-post" target="_blank">
                                    <img src={featuredIcon} alt="plugin-icon"/>
                                </a>
                            </div>
                            <div className="col-auto header-logos">
                                <a
                                    href="#"
                                    onClick={toggleNotifications}
                                    className={`nav-link ${showNotifications ? "active" : ""}`}
                                >
                                     <img src={notificationIcon} alt="plugin-icon"/>
                                </a>
                                
                                {showNotifications && (
                                    <Notification onClose={() => setShowNotifications(false)} />
                                )}
                            </div>
                            <div className="col-auto topbar-right-unit">
                                <a href="https://www.programmelab.com" target="_blank">
                                    <img className="question" src={programmelabIcon}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>                    
            </div>
        </div>
    )
}
